import { render, staticRenderFns } from "./FaQContent.vue?vue&type=template&id=c5f5e70c&"
import script from "./FaQContent.vue?vue&type=script&lang=js&"
export * from "./FaQContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports